import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldErrors,
  FieldValues,
} from 'react-hook-form';

import { EssQuestion } from '@/domain/impact-ess/entities/question.entity';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { language } from '@/ui/i18n';
import { isFactor } from '@/ui/utils/form-validations';

type Inputs = { [key: string]: string };

interface IProps {
  fields: EssQuestion['fields'];
  name: string;
  value: string;
  control: Control<FieldValues, any>; // eslint-disable-line
  onBlur: () => void;
  errors: FieldErrors<Inputs>;
}

export function FSFactorField({
  fields,
  name,
  value,
  control,
  onBlur,
  errors,
}: IProps) {
  return (
    <Controller
      control={control}
      defaultValue={value}
      name={name}
      rules={{ validate: isFactor }}
      render={({ field }) => (
        <CustomMultipleInputs
          field={field}
          fields={fields}
          onBlur={onBlur}
          errors={errors}
        />
      )}
    />
  );
}

const CustomMultipleInputs = ({
  field,
  fields,
  onBlur,
  errors,
}: {
  field: ControllerRenderProps<FieldValues, string>;
  fields: EssQuestion['fields'];
  onBlur: () => void;
  errors: FieldErrors<Inputs>;
}) => {
  const values = field.value.split('##');

  const handleValueChange = (value: string, index: number) => {
    const newValues = [...values];
    newValues[index] = value;
    field.onChange(newValues.join('##'));
  };

  return (
    <>
      {fields?.map((inputField, index) => (
        <FSTextField
          defaultValue={values[index]}
          type="number"
          label={inputField.title[language]}
          onChange={(e) => handleValueChange(e.target.value, index)}
          key={field.name + index}
          onBlur={onBlur}
          error={!!errors[field.name]}
          helperText={
            index + 1 === fields.length
              ? errors[field.name]?.message
              : undefined
          }
        />
      ))}
    </>
  );
};
